module.exports = __webpack_public_path__ + "img/ic_files.b9a1a509.svg";